enum CustomHeader {
  OperationName = "x-operation-name",
}

export default CustomHeader;
